export const GlassPanel = ({ children, className = "", alert = false, ...props }) => (
    <div
      className={`rounded-2xl p-5 ${className}`}
      style={{
        background: alert ? "rgba(239, 68, 68, 0.06)" : "rgba(15, 23, 42, 0.5)",
        border: alert ? "1px solid rgba(239, 68, 68, 0.2)" : "1px solid rgba(51, 65, 85, 0.3)",
        backdropFilter: "blur(12px)",
      }}
      {...props}
    >
      {children}
    </div>
  );